import { IProductOptionData } from "common/records/ProductOption";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";

export const FETCH_PRODUCT_OPTION = "@productOptions/FETCH_PRODUCT_OPTION";
export const RECEIVE_PRODUCT_OPTION = "@productOptions/RECEIVE_PRODUCT_OPTION";
export const RECEIVE_PRODUCT_OPTIONS = "@productOptions/RECEIVE_PRODUCT_OPTIONS";
export const RESET_PRODUCT_OPTION = "@productOptions/RESET_PRODUCT_OPTION";
export const PUSH_IMAGE_ID = "@productOptions/PUSH_IMAGE_ID";
export const RESET_IMAGE_IDS = "@productOptions/RESET_IMAGE_IDS";
export const UPDATE_PRODUCT_OPTION = "@productOptions/UPDATE_PRODUCT_OPTION";

export const ProductOptionActions = {
  fetchProductOption: (productOptionId: number) => createAction(FETCH_PRODUCT_OPTION, { productOptionId }),
  receiveProductOption: (productOption: Partial<IProductOptionData>) =>
    createAction(RECEIVE_PRODUCT_OPTION, { productOption }),
  receiveProductOptions: (productOptions: IProductOptionData[]) =>
    createAction(RECEIVE_PRODUCT_OPTIONS, { productOptions }),
  resetProductOption: (productOptionId: number) => createAction(RESET_PRODUCT_OPTION, { productOptionId }),
  pushImageId: (imageId: number) => createAction(PUSH_IMAGE_ID, { imageId }),
  resetImageIds: (productOptionId: number) => createAction(RESET_IMAGE_IDS, { productOptionId }),
  updateProductOption: (event: FormUpdateEvent) => createAction(UPDATE_PRODUCT_OPTION, { event }),
};

export type ProductOptionActions = ActionsUnion<typeof ProductOptionActions>;
